// libraries.
import { Navbar, Container, Alert } from 'react-bootstrap';
import { monserratSemiBold, robotoRegular } from '@habitech/shared';
import { useSelector } from 'react-redux';

// components.
import { SidebarOrchestrator } from '@pages/OrchestratorPricingCommitteePage/shared/SidebarOrchestrator/SidebarOrchestrator';
import {
  SearchOrchestratorPricingCommittee,
  MaxPriceDisplay,
  AliasFilterDropdown,
} from '@domains/orchestrator-pricing-committee';
import { Layout } from '@shared';

// selectors.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';

// domains.
import { CountryCode } from '@domains/country';

export const MaxPrice = () => {
  const country = useSelector(getCountry);

  return (
    <Layout>
      <SidebarOrchestrator />
      <Container fluid className="w-100 py-3">
        <Navbar className="pt-0">
          <Container fluid className="px-3">
            <div style={{ fontFamily: monserratSemiBold, fontSize: '20px' }}>
              Precio Máximo
            </div>
            {country === CountryCode.MX && (
              <div
                className="d-flex justify-content-end gap-2"
                style={{ fontFamily: robotoRegular }}
              >
                <AliasFilterDropdown />
                <SearchOrchestratorPricingCommittee />
              </div>
            )}
          </Container>
        </Navbar>
        <Container fluid className="px-3">
          {country === CountryCode.MX ? (
            <MaxPriceDisplay />
          ) : (
            <Alert variant="warning" className="mt-3">
              <div style={{ fontFamily: robotoRegular }}>
                Esta funcionalidad solo está disponible para México.
              </div>
            </Alert>
          )}
        </Container>
      </Container>
    </Layout>
  );
};
